import { DealSheetFormValues } from './types';
import { Country } from '@trnsact/trnsact-shared-types';

export const dealSheetInitialFormValues: DealSheetFormValues = {
  name: '',
  description: '',

  taxes: [],
  charges: [],

  equipment: { type: [] },
  customer: { type: [], paymentType: [] },
  address: { zip: [], state: [], county: [], country: Country.Us, city: [], postalCode: [], province: [] },
};
